import {Button, Paper, Stack, TextField, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import useSession from "../hooks/user/useSession";
import {ChangeEvent, useEffect, useState} from "react";
import {useResponsive} from "../hooks/style";

// TODO This appears to be an orphan

const UpdatePassword = () => {
  const navigate = useNavigate();
  const { updatePassword } = useSession();
  const {isDesktop, isPhone} = useResponsive();

  const passwordRegex = new RegExp(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*.[{}();.#@$^&!%*?&'"\]\[])[A-Za-z\d{}();.#@$^&!%*?&'"\]\[]{10,}$/
);

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [inputsValid, setInputsValid] = useState(false);

  const validateInputs = () => {
    const validPassword = passwordRegex.test(password);
    const validConfirmPassword = password == confirmPassword;
    const inputsValid = validPassword && validConfirmPassword;
    setInputsValid(inputsValid);
  }

  const handleTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { target: { name, value } } = event;
    switch (name) {
      case 'password':
        setPassword(value);
        break;
      case 'confirmPassword':
        setConfirmPassword(value);
        break;
      default:
        console.error(`Cannot handle change event.`);
        break;
    }
  };

  const handlePasswordUpdate = () => updatePassword(
    password,
    () => navigate('/'),
    (err: any) => console.error('Could not complete password update', err)
  );

  useEffect(validateInputs, [password, confirmPassword]);

  return (
    <Paper sx={{ px: isPhone ? 2 : 0, py: 6, maxWidth: 'sm', mx: isPhone ? 2 : 'auto' }}>
      <Stack direction='column' spacing={4} sx={{maxWidth: 300, mx: 'auto', alignItems: 'center'}}>
        <Typography variant='h4'>Update Password</Typography>

        <TextField
          variant='outlined'
          fullWidth
          error={!passwordRegex.test(password) && !!password}
          type='password'
          label='Password'
          helperText='Minimum of 10 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character.'
          name='password'
          value={password}
          onChange={handleTextChange}
        />
        <TextField
          variant='outlined'
          fullWidth
          error={password != confirmPassword}
          type='password'
          label='Confirm Password'
          name='confirmPassword'
          value={confirmPassword}
          onChange={handleTextChange}
        />
        <Stack direction="row" sx={{justifyContent: 'flex-end', width: '100%'}}>
          <Button variant='contained' color='primary' disabled={!inputsValid} onClick={handlePasswordUpdate}>Update</Button>
        </Stack>
      </Stack>
    </Paper>
  )
};

export default UpdatePassword;